import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const TimecardIcon: FC<Props> = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6001 7.20009C21.6001 9.8509 19.4509 12.0001 16.7999 12.0001C14.1491 12.0001 12 9.8509 12 7.20009C12 4.54907 14.1491 2.39989 16.7999 2.39989C19.4509 2.39989 21.6001 4.54907 21.6001 7.20009ZM24 7.20009C24 11.1766 20.7764 14.4002 16.7999 14.4002C12.8234 14.4002 9.59986 11.1766 9.59986 7.20009C9.59986 3.22358 12.8234 0 16.7999 0C20.7764 0 24 3.22358 24 7.20009ZM16.7999 16.7999C17.6288 16.7999 18.433 16.695 19.2 16.4975V24H0V2.39974H8.48426C8.05454 3.14264 7.72146 3.94843 7.50227 4.79984H2.39973V21.6002H16.7999L16.7999 16.7999ZM4.79998 7.20009H7.20007C7.20007 8.02876 7.30494 8.83296 7.50242 9.59998H4.79997L4.79998 7.20009ZM4.79998 12.0001H8.48441C9.00693 12.9035 9.67253 13.7139 10.4502 14.4002H4.80019L4.79998 12.0001ZM18.0003 4.19981H15.6002V8.39993L17.7216 10.5214L19.4186 8.82422L18.0003 7.40591V4.19981ZM14.4002 19.2002V16.8001H4.79998V19.2002H14.4002Z"
      />
    </svg>
  );
};
